import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { Toaster } from 'sonner'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import { Header } from '@/components/Header'
import { LoadingComponent } from '@/components/LoadingComponent'
import { LoginComponent } from '@/components/LoginComponent'
import { AuthProvider } from '@/contexts/AuthContext'
import { BandProvider } from '@/contexts/BandContext'
import { useAuth } from '@/hooks/useAuth'
import { BandsPage } from '@/pages/BandsPage'
import { RepertoirePage } from '@/pages/RepertoirePage'
import { SetlistsPage } from '@/pages/SetlistsPage'
import { SetlistEditorPage } from '@/pages/SetlistEditorPage'
import { PrintSetlistPage } from '@/pages/PrintSetlistPage'

const AppContent = () => {
  const { user, loading } = useAuth()

  if (loading) {
    return <LoadingComponent />
  }

  if (!user) {
    return <LoginComponent />
  }

  return (
    <BandProvider>
      <Header />
      <Routes>
        <Route path='/' element={<BandsPage />} />
        <Route path='/repertoire' element={<RepertoirePage />} />
        <Route path='/setlists' element={<SetlistsPage />} />
        <Route path='/setlists/:id' element={<SetlistEditorPage />} />
        <Route path='/setlists/:id/print' element={<PrintSetlistPage />} />
        <Route path='*' element={<Navigate to='/' replace />} />
      </Routes>
    </BandProvider>
  )
}

const App = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ErrorBoundary>
          <AppContent />
        </ErrorBoundary>
      </BrowserRouter>
      <Toaster />
    </AuthProvider>
  )
}

export default App
